import Spinner from 'components/Shared/Loader';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import styles from './styles.scss';
import cn from 'classnames';
import { PageState } from 'models/PageState';
import { LoadingStatus } from 'models/LoadingStatus';
import { createSelector } from 'reselect';
import { NoSsr } from '@bygghemmait/components';

interface ContainerProps {
  children: ReactNode;
  isMounted?: boolean;
  isVisible?: boolean;
}

const loadingSelector = createSelector(
  (state: PageState) => state.currentPage,
  page => page.status === LoadingStatus.Loading
);
const Container = ({ children }: ContainerProps): JSX.Element => {
  const isLoading = useSelector(loadingSelector);
  return (
    <div
      className={cn(styles.container, {
        [styles.in]: isLoading
      })}
    >
      {children}
    </div>
  );
};

export const Loader = (): JSX.Element | null => (
  <NoSsr defer>
    <Container>
      <Spinner loading className={styles.spinner} />
    </Container>
  </NoSsr>
);
